import { useCallback, useEffect, useState } from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { Edit, Form, Input, Switch, useForm } from "@pankod/refine-antd";

import { IUser } from "../../interfaces";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IUser>();
  const [isStaff, isSetStaff] = useState(false);

  const userIsStaff = useCallback(() => {
    if (queryResult?.data?.data?.role?.data?.attributes?.type === "dashboard") {
      return true;
    } else {
      return false;
    }
  }, [queryResult?.data?.data?.role?.data?.attributes?.type]);

  useEffect(() => {
    isSetStaff(userIsStaff());
  }, [userIsStaff]);

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          if (values.password === undefined) {
            delete values.password;
          }
          return formProps.onFinish?.({
            ...values,
            role: isStaff ? 3 : 1,
          });
        }}
      >
        {/* <Form.Item label="Locale" name="locale">
          <Radio.Group disabled>
            <Radio.Button value="en">English</Radio.Button>
            <Radio.Button value="de">Deutsch</Radio.Button>
          </Radio.Group>
        </Form.Item> */}
        <Form.Item
          wrapperCol={{ span: 8 }}
          label="Username"
          name="username"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 8 }}
          label="Password"
          name="password"
          rules={[
            {
              min: 6,
            },
          ]}
        >
          <Input.Password placeholder="input password" />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 14 }}
          label="Full name"
          name="full_name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 8 }}
          label="Email"
          name="email"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Staff" name={"role"}>
          <Switch
            checked={isStaff}
            onChange={(value) => {
              isSetStaff(value);
            }}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
